"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utilities_1 = require("../simple/utilities");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var quick_filter_dto_1 = require("../../service/quick-filter-dto");
var StateDto = /** @class */ (function () {
    function StateDto(pageSize) {
        this._pageOptions = new idm_de_core_frontend_1.PagingOptions(0, pageSize);
    }
    Object.defineProperty(StateDto.prototype, "defaultFilters", {
        get: function () {
            return this._defaultFilters;
        },
        set: function (value) {
            this._defaultFilters = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StateDto.prototype, "advancedFilters", {
        get: function () {
            return this._advancedFilters;
        },
        set: function (value) {
            this._advancedFilters = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StateDto.prototype, "quickFilters", {
        get: function () {
            return this._quickFilters;
        },
        set: function (value) {
            this._quickFilters = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StateDto.prototype, "externalFilters", {
        get: function () {
            return this._externalFilters;
        },
        set: function (value) {
            this._externalFilters = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StateDto.prototype, "searchFilters", {
        get: function () {
            return this._searchFilters;
        },
        set: function (value) {
            this._searchFilters = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StateDto.prototype, "pageOptions", {
        get: function () {
            return this._pageOptions;
        },
        set: function (value) {
            this._pageOptions = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StateDto.prototype, "sortingOptions", {
        get: function () {
            return this._sortingOptions;
        },
        set: function (value) {
            this._sortingOptions = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StateDto.prototype, "stateId", {
        get: function () {
            return this._stateId;
        },
        set: function (value) {
            this._stateId = value;
        },
        enumerable: true,
        configurable: true
    });
    StateDto.prototype.toJson = function () {
        var finalObject = {};
        if (this.advancedFilters && !utilities_1.isNullOrEmptyObject(this.advancedFilters)) {
            finalObject['advancedFilters'] = utilities_1.mapToJson(this.advancedFilters);
        }
        if (this.quickFilters && !utilities_1.isNullOrEmptyObject(this.quickFilters)) {
            finalObject['quickFilters'] = this.quickFilters.toJson();
        }
        if (this.externalFilters && !utilities_1.isNullOrEmptyObject(this.externalFilters)) {
            finalObject['externalFilters'] = this.externalFilters;
        }
        if (this.searchFilters && !utilities_1.isNullOrEmptyObject(this.searchFilters)) {
            finalObject['searchFilters'] = this.searchFilters;
        }
        if (this.sortingOptions && !utilities_1.isNullOrEmptyObject(this.sortingOptions)) {
            finalObject['sorting'] = this.sortingOptions;
        }
        if (this.pageOptions && !utilities_1.isNullOrEmptyObject(this.pageOptions)) {
            finalObject['paging'] = this.pageOptions;
        }
        if (this.stateId) {
            finalObject['stateId'] = this.stateId;
        }
        return JSON.stringify(finalObject);
    };
    StateDto.prototype.fromJson = function (stateStr) {
        var stateJSON = stateStr ? JSON.parse(stateStr) : {};
        this.advancedFilters = utilities_1.jsonToMap((stateJSON && stateJSON['advancedFilters']) || "{}");
        var emptyQuickFilter = new quick_filter_dto_1.QuickFilterDto(undefined, undefined);
        emptyQuickFilter.fromJson((stateJSON && stateJSON['quickFilters']) || "{}");
        this.quickFilters = emptyQuickFilter;
        this.searchFilters = (stateJSON && stateJSON['searchFilters']) || {};
        this.externalFilters = (stateJSON && stateJSON['externalFilters']) || {};
        this.pageOptions = (stateJSON && stateJSON['paging']);
        this.sortingOptions = (stateJSON && stateJSON['sorting']);
    };
    return StateDto;
}());
exports.StateDto = StateDto;
//# sourceMappingURL=state-dto.js.map